import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-hot-toast";

const FormWidget = ({ widget, slug, apiBaseUrl, token, onSuccessNavigate }) => {
  const fields = widget.props?.fields || [];
  const [values, setValues] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (name, value) => {
    setValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      const res = await axios.post(
        `${apiBaseUrl}/pages/${slug}/widgets/${widget.id}/submit`,
        values,
        { headers }
      );
      setSubmitted(true);
      toast.success(res.data.success_message || "Submitted successfully.");
      if (res.data.navigate_to_slug && onSuccessNavigate) {
        onSuccessNavigate(res.data.navigate_to_slug);
      }
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Submission failed.");
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return <div className="text-green-600 font-medium">Thanks — your submission was received.</div>;
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4 bg-white rounded-lg border border-gray-200 p-5">
      {widget.title && <h3 className="font-semibold text-lg">{widget.title}</h3>}
      {fields.map((field) => (
        <div key={field.name}>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {field.label || field.name}
            {field.required && <span className="text-red-500"> *</span>}
          </label>
          <input
            type={field.field_type === "NUMBER" ? "number" : "text"}
            required={!!field.required}
            value={values[field.name] ?? ""}
            onChange={(e) => handleChange(field.name, e.target.value)}
            className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm"
          />
        </div>
      ))}
      <button
        type="submit"
        disabled={submitting}
        className="rounded-md bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700 disabled:opacity-50"
      >
        {submitting ? "Submitting…" : widget.props?.submit_label || "Submit"}
      </button>
    </form>
  );
};

export default FormWidget;
